import thMessages from '../locales/th_TH.json';

const ThLang = {
  messages: {
    ...thMessages,
  },
  locale: 'th-TH',
};
export default ThLang;
